import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LoadReceptionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                d='M21.4136 10.7996L20.17 7.06867C19.9282 6.36049 19.2718 5.88549 18.5291 5.88549H18.0455C17.6136 5.88473 17.6568 5.88477 17.1818 5.88477H16.3182C15.8432 5.88477 16.3182 5.88477 15.4545 5.88507L13.7273 5.88549C12.7773 5.88549 12 6.66276 12 7.61276V11.0673H2.5V15.3855C2.5 16.3355 3.27727 17.1128 4.22727 17.1128H5.09091C5.09091 18.5464 6.24818 19.7037 7.68182 19.7037C9.11545 19.7037 10.2727 18.5464 10.2727 17.1128H13.7273C13.7273 18.5464 14.8845 19.7037 16.3182 19.7037C17.7518 19.7037 18.9091 18.5464 18.9091 17.1128H21.5V11.3437C21.5 11.1623 21.4741 10.9809 21.4136 10.7996ZM7.68182 17.9764C7.20682 17.9764 6.81818 17.5878 6.81818 17.1128C6.81818 16.6378 7.20682 16.2491 7.68182 16.2491C8.15682 16.2491 8.54545 16.6378 8.54545 17.1128C8.54545 17.5878 8.15682 17.9764 7.68182 17.9764ZM16.3182 17.9764C15.8432 17.9764 15.4545 17.5878 15.4545 17.1128C15.4545 16.6378 15.8432 16.2491 16.3182 16.2491C16.7932 16.2491 17.1818 16.6378 17.1818 17.1128C17.1818 17.5878 16.7932 17.9764 16.3182 17.9764ZM13.7273 11.0673V7.61276H18.5291L19.6777 11.0673H13.7273Z'
            />
            <Path
                fill='currentColor'
                d='M2.5 5.0222C2.5 4.06825 3.27333 3.29492 4.22727 3.29492H9.40909C10.363 3.29492 11.1364 4.06825 11.1364 5.02219V10.204H2.5V5.0222Z'
            />
        </>
    ),
})

LoadReceptionIcon.displayName = 'LoadReceptionIcon'
